import apiService from './apiService';
import apiServiceNew from './apiService.new';
import {stringify} from 'query-string';

export default (function () {

	var servicePath = '/Email';
	var parseOptions = {
		'datetimes': [
			'WhenDate', 'CreateDate', 'ModifyDate', 'DeleteDate', 'SentDate', 'ScheduleDate'
		]
	};
	const ITEMS_PER_FETCH = 10;

	const decodeBody = ({Body, ...rest}) => ({
		...rest, Body: Body && CKEDITOR.tools.htmlDecode(Body)
	});
	const encodeBody = ({Body, ...rest}) => ({
		...rest, Body: Body && CKEDITOR.tools.htmlEncode(Body)
	});

	function toFormDataOptions({Attachments, ...email}) {
		var formData = new FormData();

		email = encodeBody(email);

		formData.append('email', JSON.stringify(email));

		if (Attachments) {
			formData.append('attachments', JSON.stringify(Attachments));
		}

		return {
			data: formData,
			cache: false,
			contentType: false,
			processData: false
		};
	}

	function fetch(sent, params) {
		params.sent = sent;
		const url = servicePath + '?' + stringify(params, {
			arrayFormat: 'index'
		});

		return apiService.get(url)
			.then(function(data) {
				var totalResult = data.result;
				// parse data
				var res = totalResult.splice(0, ITEMS_PER_FETCH);

				res = res.map(decodeBody);
				if (res instanceof Array) {
					for (let i = 0; i < res.length; i++) {
						apiService.parse(res[i], parseOptions);
					}
				}
				res.hasMore = data.hasMore;
				res.showSentBy = data.showSentBy;
				return res;
			});
	}

	function get(id, isCampaignEmail) {
		var url = `${servicePath}/${id}?isCampaignEmail=${isCampaignEmail}`;

		return apiService.get(url)
			.then(function(data) {
				apiService.parse(data, parseOptions);
				return decodeBody(data);
			});
	}

	function create(email) {
		var url = servicePath;

		return apiService.post({}, url, toFormDataOptions(email))
			.then(function(data) {
				apiService.parse(data, parseOptions);
				return decodeBody(data);
			});
	}

	function update(id, email) {
		var url = servicePath + '/' + id;

		return apiService.put({}, url, toFormDataOptions(email))
			.then(function (data) {
				apiService.parse(data, parseOptions);
				return decodeBody(data);
			});
	}

	function remove(id) {
		var url = servicePath + '/' + id;

		return apiService.delete(null, url);
	}

	const removeSchedule = (id) => apiServiceNew.put(`${servicePath}/removeEmailSchedule/${id}`);

	function send(message) {
		const url = servicePath + '/send';
		const formDataOptions = toFormDataOptions(message);

		return apiServiceNew.post(url, formDataOptions.data);
	}

	const getDraftedEmails = (rowCount, selectedPage, sortByColumn, sortDirection, userArray) => {
		const url = `${servicePath}/getDraftsList`;
		var jsonParam = {
			offset: (selectedPage - 1) * rowCount,
			limit: rowCount,
			sortByColumn,
			sortDirection,
			userArray
		};

		const newUrl = url + '?' + stringify(jsonParam, {
			arrayFormat: 'index'
		});

		return apiServiceNew.get(newUrl);
	};

	const getScheduledEmails = (rowCount, selectedPage, sortByColumn, sortDirection, userArray) => {
		const url = `${servicePath}/getScheduledList`;
		var jsonParam = {
			offset: (selectedPage - 1) * rowCount,
			limit: rowCount,
			sortByColumn,
			sortDirection,
			userArray
		};

		const newUrl = url + '?' + stringify(jsonParam, {
			arrayFormat: 'index'
		});

		return apiServiceNew.get(newUrl);
	};

	return {
		fetch: fetch,
		get: get,
		create: create,
		update: update,
		remove: remove,
		send: send,
		removeSchedule: removeSchedule,
		getDraftedEmails: getDraftedEmails,
		getScheduledEmails: getScheduledEmails
	};
})();